import React from 'react';
import { Props } from './Success.types';
import { Button } from 'lmc-ui-library-rebrand';

import './_statuses.scss';

const Success: React.FC<Props> = ({
  onConfirm,
  message = `Thanks for registering, we’ll be in touch.`,
  additionalMessage = '',
  confirmLabelText = `Return to home page`,
}) => {
  return (
    <div className="status status-success">
      <div className="status__container">
        <h1>{message}</h1>
        <p>{additionalMessage}</p>
        <Button label={confirmLabelText} onClick={onConfirm} className="status__button" />
      </div>
    </div>
  );
};

export default Success;
